import React from 'react';
import { css } from 'glamor'
import { ReactSVG } from 'react-svg';

interface IconProps {
    name: string;
    width?: string;
    height?: string;
    color?: string;
    cursor?: string;
    buttonClick?: () => void;
}

function Icon({ name, width = '30', height = '30', color = 'black', cursor = "default", buttonClick }: IconProps) {
    const iconPath = require(`../../../../assets/icons/${name ?? 'token-fitpal'}.svg`);
    const styles = css({
        ' svg ': {
            height: height,
            width: width,
        },
        ' svg path': {
            fill: color
        },
    })

    return (
        <ReactSVG
            style={{ cursor: cursor }}
            width={width}
            height={height}
            src={iconPath}
            {...styles}
            onClick={() => buttonClick && buttonClick()}
        />
    );
}

export default Icon;
